import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { LockOutlined as LockIcon } from '@mui/icons-material';
import logo from '../assets/images/logo.png';

const SessionExpired: React.FC = () => {
  const handleLoginRedirect = () => {
    window.location.href = 'https://erp.mafagencement.com/login';
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%', textAlign: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <img
              src={logo}
              alt="M.A.F Agencement Logo"
              style={{ height: '100px', width: 'auto' }}
            />
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <Box
              sx={{
                backgroundColor: '#f44336',
                borderRadius: '50%',
                width: 80,
                height: 80,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <LockIcon sx={{ fontSize: 40, color: 'white' }} />
            </Box>
          </Box>

          <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            Accès Interdit
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Vous n'avez pas la permission d'accéder à ce fichier. Veuillez vous connecter pour continuer.
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={handleLoginRedirect}
            sx={{
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
              px: 4,
              py: 1.5,
            }}
          >
            Se connecter
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default SessionExpired;
